const templateUri = {
  outofserviceRecoveryPath: "1/api/OutOfServiceRecovery",
  otsHistoryPath: "1/api/OutOfServiceRecovery/GetOtsHistory",
  flightPath:"1/api/OutOfServiceRecovery/FlightPath",
  etopsAircraftPath: "1/api/OutOfServiceRecovery/etops",
  stationSETDPath: "1/api/OutOfServiceRecovery/airlines/{airline}/aircraft/{aircraftRegistration}/location",
  ataCodePath: "1/api/OutOfServiceRecovery/ATACode",
  outofserviceRecoveryEventPath: "1/api/OutOfServiceRecovery/airlines",
  closedEvents: "1/api/OutOfServiceRecovery/GetOutOfServiceRecoveryClosedEvent",
  canReopenEvent: "1/api/OutOfServiceRecovery/airlines/",
  refreshEventType: "1/api/OutOfServiceRecovery/airlines",
  syncStatus: "1/api/OutOfServiceRecovery/airlines/{airline}/events/syncstatus",
  getAllAircraftsPath: "1/api/OutOfServiceRecovery/GetAllAircraftsList",
  getAircraftInFleet: "1/api/OutOfServiceRecovery/airlines/{airline}/fleets/{fleetCode}/aircraft",
  getFleetTypespath: "1/api/OutOfServiceRecovery/FleetTypes",
  closedEventsReport: "1/api/OutOfServiceRecovery/GetClosedEventReport",
  aogPartsPath: "1/api/AogParts/airlines/{airline}/events/{eventId}/parts",
};

export default templateUri;
